var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"mainChart"}},[_c('apexchart',{key:0,staticClass:"response-chart",attrs:{"type":"area","series":_vm.responseAndUptimeData,"height":"200","width":"100%","options":_vm.mainChartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }